// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDE4tu18C2vRMtNaMsvU8i-L-xDPno4rU0",
  authDomain: "gymmixapp.firebaseapp.com",
  projectId: "gymmixapp",
  storageBucket: "gymmixapp.firebasestorage.app",
  messagingSenderId: "28095607222",
  appId: "1:28095607222:web:8992fb52f6e20565329117",
  measurementId: "G-9C12SSTZMZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
